import { muscle } from '../lib/catalog.ts';
import { relative } from '../lib/format.ts';
import { useModel } from '../state.tsx';
import { Card, Empty, Pill } from '../ui/components.tsx';

/** Notes trainers sent over WhatsApp. Always visible to the trainee (product rule). */
export function Notes() {
  const model = useModel();
  return (
    <div className="screen">
      <h1>Trainer notes</h1>
      {!model.notes.length && (
        <Empty title="No notes yet" detail={model.links.length
          ? 'Notes your trainer sends to the Recover WhatsApp bot appear here.'
          : 'Link your trainer from the You tab. Their notes about you will appear here.'} />
      )}
      {model.notes.map((n) => (
        <Card key={n.id}>
          <div className="row caption"><span>{n.trainer_name}</span><span className="spacer" /><span>{relative(n.created_at)}</span></div>
          <p>{n.body}</p>
          <div className="pills">
            {n.raise_next_session && !n.raised_at && <Pill text="Next session" color="var(--warning)" />}
            {n.raised_at && <Pill text="Raised" color="var(--text-2)" />}
            {n.muscle_ids.map((id) => muscle(id) && <Pill key={id} text={muscle(id)!.name} />)}
          </div>
        </Card>
      ))}
    </div>
  );
}
